/* Folliva product-page tracking (2026-10-10, Oliver: "viso product page trackinga… ar išėjo į kitą puslapį, ar uždarė").
   Anonymous, no cookies: a random id per page load (vid) and per tab (sid, sessionStorage). Rows go to Supabase page_events:
   view  = page opened
   leave = summary each time the page is hidden or closed (max 6): seconds, visible seconds, max scroll %, deepest section,
           seconds per section, last 40 clicks (button / link / size text), selected size, autoship on/off, add-to-cart count, link clicked
   land  = sent by snippets/fl-page-track.liquid on the NEXT page in the same tab (no land = the tab was closed or the visitor left the site). */
(function () {
  'use strict';
  var C = window.FL_PT || {}; if (!C.u || !C.k) return;
  function rid() { try { return crypto.randomUUID().replace(/-/g, ''); } catch (e) { return (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 32); } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function cut(s, n) { s = String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n) : s; }
  function send(row) {
    try {
      fetch(C.u.replace(/\/$/, '') + '/rest/v1/page_events', {
        method: 'POST', keepalive: true,
        headers: { apikey: C.k, Authorization: 'Bearer ' + C.k, 'Content-Type': 'application/json', Prefer: 'return=minimal' },
        body: JSON.stringify(row)
      }).catch(function () {});
    } catch (e) {}
  }

  var vid = rid(), t0 = Date.now(), sid = ss('fl_sid') || (function () { var s = rid(); ss('fl_sid', s); return s; })();
  window.__flPdpVid = vid;
  var q = new URLSearchParams(location.search), utm = {};
  ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (k) { var v = q.get('utm_' + k); if (v) utm[k] = v; });
  if (!utm.source) { try { utm = JSON.parse(ss('fl_utm') || '{}') || {}; } catch (e) { utm = {}; } }
  var w = window.innerWidth || 0, device = w < 768 ? 'mobile' : (w < 1100 ? 'tablet' : 'desktop');
  var ref = ''; try { if (document.referrer) { var r = new URL(document.referrer); ref = cut(r.host + r.pathname, 200); } } catch (e) {}
  var base = {
    vid: vid, sid: sid, page: cut(location.pathname.split('/').filter(Boolean).pop() || 'product', 60), path: cut(location.pathname, 200),
    utm_source: utm.source ? cut(utm.source, 150) : null, utm_medium: utm.medium ? cut(utm.medium, 150) : null,
    utm_campaign: utm.campaign ? cut(utm.campaign, 150) : null, utm_content: utm.content ? cut(utm.content, 150) : null,
    utm_term: utm.term ? cut(utm.term, 150) : null, referrer: ref || null, device: device
  };
  function row(event, data) { var o = {}; for (var k in base) o[k] = base[k]; o.event = event; o.data = data; return o; }

  /* page state */
  function size() { var i = document.querySelector('fl-variant-picker input[type=radio]:checked, [data-fl-variant-picker] input[type=radio]:checked'); return i ? cut(i.value, 20) : null; }
  function auto() { var i = document.querySelector('[data-fl-subs-toggle]'); return i ? !!i.checked : null; }

  /* sections: the template's own sections in page order */
  var secs = [];
  function mapSecs() {
    secs = [].slice.call(document.querySelectorAll('main .shopify-section, #MainContent .shopify-section')).filter(function (el, i, a) { return a.indexOf(el) === i && el.offsetHeight > 40; }).map(function (el) {
      var id = el.id || '', n = id.indexOf('__') > -1 ? id.split('__').pop() : id.replace('shopify-section-', '');
      return { el: el, n: cut(n.replace(/_[A-Za-z0-9]{6}$/, ''), 30) || 'section' };
    });
  }
  var visT = 0, visFrom = document.visibilityState === 'visible' ? Date.now() : 0, maxY = 0, deep = -1, tsec = {}, clicks = [], atc = 0, nextHref = null, nextAt = 0, sent = 0, lastClick = 0, lastLeave = 0;
  function visNow() { return visT + (visFrom ? Date.now() - visFrom : 0); }
  function scrollPct() { var h = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) || 1; return Math.min(100, Math.round(100 * maxY / h)); }
  function onScroll() {
    var y = (window.pageYOffset || 0) + window.innerHeight; if (y > maxY) maxY = y;
    for (var i = secs.length - 1; i > deep; i--) { var r = secs[i].el.getBoundingClientRect(); if (r.top < window.innerHeight * 0.6) { deep = i; break; } }
  }
  function curSec() { var mid = window.innerHeight / 2; for (var i = 0; i < secs.length; i++) { var r = secs[i].el.getBoundingClientRect(); if (r.top <= mid && r.bottom >= mid) return secs[i].n; } return null; }
  var raf = 0; window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; onScroll(); }); }, { passive: true });
  setInterval(function () { if (document.visibilityState !== 'visible') return; var s = curSec(); if (s) tsec[s] = (tsec[s] || 0) + 1; }, 1000);

  /* clicks: what was pressed, never what was typed */
  document.addEventListener('click', function (e) {
    try {
      var el = e.target && e.target.closest && e.target.closest('a,button,label,summary,input,select,[role=button],[data-fl-card],img');
      if (!el) return;
      if (e.timeStamp - lastClick < 80) return; /* a label click re-fires on its input: keep one */
      lastClick = e.timeStamp;
      var k = '', tag = el.tagName, to = null;
      if (el.matches('[data-fl-atc], [data-fl-atc] *, button[name=add]')) { atc++; k = 'add to cart'; }
      else if (el.hasAttribute('data-fl-card') || (tag === 'LABEL' && el.querySelector('input[type=radio]'))) k = 'size ' + (el.getAttribute('data-value') || (el.querySelector('input') || {}).value || '');
      else if (tag === 'INPUT' && el.type === 'checkbox') k = (el.hasAttribute('data-fl-subs-toggle') ? 'autoship ' : 'check ') + (el.checked ? 'on' : 'off');
      else if (tag === 'INPUT' && (el.type === 'text' || el.type === 'email' || el.type === 'number' || el.type === 'search')) k = 'field ' + (el.name || el.type);
      else if (tag === 'LABEL' && el.querySelector('[data-fl-subs-toggle]')) k = 'autoship ' + (el.querySelector('[data-fl-subs-toggle]').checked ? 'off' : 'on');
      else if (tag === 'SUMMARY') k = 'open ' + el.textContent;
      else if (tag === 'IMG') k = 'image ' + (el.alt || '');
      else k = (el.getAttribute('aria-label') || el.textContent || el.value || tag.toLowerCase());
      if (tag === 'A' && el.href) {
        try { var u = new URL(el.href, location.href); to = cut(u.host === location.host ? u.pathname : u.host, 120); nextHref = to; nextAt = Date.now(); } catch (x) {}
      }
      var c = [Math.round((Date.now() - t0) / 1000), cut(String(k).replace(/[→›»]+/g, ''), 50)]; if (to) c.push(to);
      clicks.push(c); if (clicks.length > 40) clicks.shift();
    } catch (x) {}
  }, true);

  function summary(why) {
    var top = Object.keys(tsec).sort(function (a, b) { return tsec[b] - tsec[a]; }).slice(0, 8), ts = {};
    top.forEach(function (k) { ts[k] = tsec[k]; });
    var d = {
      why: why, n: sent + 1, secs: Math.round((Date.now() - t0) / 1000), vis: Math.round(visNow() / 1000), sc: scrollPct(),
      deep: deep > -1 && secs[deep] ? secs[deep].n : null, deep_i: deep + 1, sec_n: secs.length, at: curSec(), tsec: ts,
      clicks: clicks.slice(-40), size: size(), auto: auto(), atc: atc
    };
    if (nextHref && Date.now() - nextAt < 4000) d.next = nextHref;
    if (navigator.webdriver) d.bot = true;
    return d;
  }
  function leave(why) {
    if (sent >= 6) return;
    if (why === 'hide' && Date.now() - lastLeave < 1500) return; /* pagehide already sent this one */
    lastLeave = Date.now();
    send(row('leave', summary(why))); sent++;
    ss('fl_pdp_last', JSON.stringify({ vid: vid, t: Date.now() }));
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (visFrom) { visT += Date.now() - visFrom; visFrom = 0; } leave('hide'); }
    else { visFrom = Date.now(); ss('fl_pdp_last', null); }
  });
  window.addEventListener('pagehide', function () { if (visFrom) { visT += Date.now() - visFrom; visFrom = 0; } leave('close'); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { visFrom = Date.now(); ss('fl_pdp_last', null); } });

  function start() {
    mapSecs(); onScroll();
    send(row('view', { size: size(), auto: auto(), vw: w, vh: window.innerHeight || 0, sec_n: secs.length, bot: navigator.webdriver ? true : undefined }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { mapSecs(); });
})();
